module.exports = __webpack_public_path__ + "img/cask.d760283b.jpg";